import type { FaireProductEntity } from "../../entity_types/product";

export const p_sjk8xv95zb: FaireProductEntity = {
  token: "p_sjk8xv95zb",
  type: "product",
  name: "Christmas Tree Plaid Girls Romper Petals Collar Ruffle",
  brandToken: "b_xvvfvktx6s",
  brandName: "Rylee Faith Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/c1a8c0ef33b745bdb79eabb2ed05316a61fb76b59eb1d6be39fd511ef7f5b1b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8693d0a9e32e455c9d05b05ba95907a18058337809db4032bfa2eda3b731dd94.jpeg",
    "https://cdn.faire.com/fastly/e99029b8aee9a0ce6b1b4dc61889914742cb05582d6dc2798ba6fbe2877023cf.jpeg",
    "https://cdn.faire.com/fastly/4f2a49524dfd98dedccf6e3e08f59b9fa15e05e10182652d1c39f488a726bf66.jpeg",
    "https://cdn.faire.com/fastly/023fd92d56cd43212416367e26797317d08fc857b71c0a58e8a710a676ea5558.jpeg",
  ],
  priceDollars: 13.49,
  description:
    "This festive Christmas romper features a classic plaid pattern, embroidered Christmas tree detail, elegant Petals Collar with green ruffle trim, puff sleeves with bow ties, and ruffle leg openings. Designed for comfort and holiday charm, perfect for Christmas celebrations, family photos, and seasonal outings.\n\nSKU:RPG62612\n\nBody：95%polyester，5%spandex Combo:97%cotton,3%spandex\n\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 26.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:27.582Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
